/**
 * Build mismatch: when `server:hello.buildSha` differs from this tab's build,
 * offer a reload ("A new version of Wordloom is available" + Reload). Shown
 * once per server build; a sticky toast so it is discoverable, not forced.
 */
import { useEffect, useRef } from 'react';
import { BUILD_SHA, isBuildMismatch } from '../buildInfo';
import { useRoomStore } from '../state/roomStore';
import { useUiStore } from '../state/uiStore';

export function UpdatePrompt() {
  const serverSha = useRoomStore((s) => s.hello?.buildSha ?? null);
  const notified = useRef<string | null>(null);

  useEffect(() => {
    if (!serverSha || !isBuildMismatch(BUILD_SHA, serverSha) || notified.current === serverSha) return;
    notified.current = serverSha;
    useUiStore.getState().toast('A new version of Wordloom is available', {
      id: 'update',
      kind: 'info',
      duration: 0,
      action: { label: 'Reload', run: () => window.location.reload() },
    });
  }, [serverSha]);

  return null;
}
